<template>
  <v-container fluid fill-height>
      <v-row align="center" justify="center" class="d-flex flex-column">
        <v-img max-width="250px" src="../assets/firme/bg-logo.png"></v-img>
        <h1>ГРЕШКА!</h1>
        <p>Извињавамо се, тражена страница није пронаћена</p>
        <v-btn color="primary" @click="$router.go(-1)">
          NAZAD
        </v-btn>
      </v-row>
  </v-container>
</template>

<script>
export default {
  name: "NotFound",

  data: () => ({})
};
</script>
